module.exports = __webpack_public_path__ + "img/audio_classify2.8d87ff59.png";